module.exports = __webpack_public_path__ + "img/Award.ad0396b3.jpg";